import React from "react";

interface InputSelectInterface {
  placeHolder: string;
  options: any[];
  disabled?: boolean;
  name?: string;
  register?: any;
  defaultValue?: any;
  id?: any;
}

export const InputSelect = ({
  placeHolder,
  options,
  disabled,
  name,
  id,
  register,
  defaultValue,
}: InputSelectInterface) => {
  return (
    <div className="input-field m-0">
      <select
        className="browser-default m-0"
        id={name}
        name={name}
        ref={register}
        defaultValue={defaultValue}
        disabled={disabled}
      >
        <option value="" disabled selected>
          {placeHolder}
        </option>
        {options.map((option: any) => (
          <option
            key={option.id}
            value={option.value}
            selected={option.value === defaultValue ? true : false}
          >
            {option.name}
          </option>
        ))}
      </select>
      {/* <ErrorCustom errors={errors} name="civilStatus" /> */}
    </div>
  );
};
